import { render, staticRenderFns } from "./PhotoEditor.vue?vue&type=template&id=90def1a4&scoped=true&"
import script from "./PhotoEditor.vue?vue&type=script&lang=js&"
export * from "./PhotoEditor.vue?vue&type=script&lang=js&"
import style0 from "./PhotoEditor.vue?vue&type=style&index=0&id=90def1a4&scoped=true&lang=css&"
import style1 from "./PhotoEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90def1a4",
  null
  
)

export default component.exports